import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(() => ({
  dropdown: {
    '& .MuiSelect-root': {
      backgroundColor: '#f7f7f7',
      height: '53px',
      borderRadius: '5px',
      padding: '0 16px',
      paddingRight: '40px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& .MuiSvgIcon-root': {
      right: '7px',
    },
  },
  alert: {
    padding: '20px',
    color: '#3E8CC1',
    '& .text': {
      color: '#3E8CC1 !important',
      fontWeight: 400,
      lineHeight: '16.34px !important',
    },
    '& .subText': {
      color: '#3E8CC1 !important',
    },
    marginBottom: 'unset',
  },
  warning: {
    padding: '20px',
    color: 'rgb(33, 37, 41) !important',
    '& .text': {
      color: 'rgb(33, 37, 41) !important',
      fontWeight: '400 !important',
      lineHeight: '16.34px !important',
    },
    '& .subText': {
      color: 'rgb(33, 37, 41) !important',
    },
    marginBottom: 'unset',
  },
}), { name: 'Funding' });

export default useStyles;
